module.exports = __webpack_public_path__ + "img/mWelcome.8b14fd69.svg";